import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminShell, ProtectedRoute } from "@/components/admin/AdminShell";
import { AdminLogin } from "@/pages/admin/Login";
import { Dashboard } from "@/pages/admin/Dashboard";
import { LiveRentals } from "@/pages/admin/LiveRentals";
import { Calendar } from "@/pages/admin/Calendar";
import { Products } from "@/pages/admin/Products";
import { Bundles } from "@/pages/admin/Bundles";
import { Promos } from "@/pages/admin/Promos";
import { RefundReport } from "@/pages/admin/RefundReport";
import { StockRequests } from "@/pages/admin/StockRequests";
import { Inventory } from "@/pages/admin/Inventory";
import { Categories } from "@/pages/admin/Categories";
import { Zones } from "@/pages/admin/Zones";
import { Reservations } from "@/pages/admin/Reservations";
import { Drivers } from "@/pages/admin/Drivers";
import { TaxReport } from "@/pages/admin/TaxReport";
import { SiteContent } from "@/pages/admin/SiteContent";
import { RefundQueue } from "@/pages/admin/RefundQueue";
import { ChangeRequests } from "@/pages/admin/ChangeRequests";
import { OwnerInbox } from "@/pages/admin/OwnerInbox";
import { BookingSettings } from "@/pages/admin/BookingSettings";
import { MessageTemplates } from "@/pages/admin/MessageTemplates";
import { RunSheet } from "@/pages/admin/RunSheet";
import { PromoCodes } from "@/pages/admin/PromoCodes";
import { Labels } from "@/pages/admin/Labels";
import { DriverScan } from "@/pages/admin/DriverScan";
import { MyRoute } from "@/pages/admin/MyRoute";
import { RouteBuilder } from "@/pages/admin/RouteBuilder";
import { Payouts } from "@/pages/admin/Payouts";
import { BlogPosts } from "@/pages/admin/BlogPosts";
import { Partners } from "@/pages/admin/Partners";
import { PayoutScenarios } from "@/pages/admin/PayoutScenarios";
import NotificationCenter from "@/pages/admin/NotificationCenter";
import { CalendarSettings } from "@/pages/admin/CalendarSettings";
import { StagePrep } from "@/pages/admin/StagePrep";
import { ThirdPartyLabels } from "@/components/admin/ThirdPartyLabels";

export const AdminApp = () => {
  return (
    <>
      <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#0F1E2C", color: "#F6F1E4", border: "1px solid rgba(255,209,102,0.28)" } }} />
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route index element={<ProtectedRoute><AdminShell><Dashboard /></AdminShell></ProtectedRoute>} />
        <Route path="live" element={<ProtectedRoute><AdminShell><LiveRentals /></AdminShell></ProtectedRoute>} />
        <Route path="calendar" element={<ProtectedRoute><AdminShell><Calendar /></AdminShell></ProtectedRoute>} />
        <Route path="products" element={<ProtectedRoute><AdminShell><Products /></AdminShell></ProtectedRoute>} />
        <Route path="bundles" element={<ProtectedRoute><AdminShell><Bundles /></AdminShell></ProtectedRoute>} />
        <Route path="promos" element={<ProtectedRoute><AdminShell><Promos /></AdminShell></ProtectedRoute>} />
        <Route path="refund-report" element={<ProtectedRoute><AdminShell><RefundReport /></AdminShell></ProtectedRoute>} />
        <Route path="stock-requests" element={<ProtectedRoute><AdminShell><StockRequests /></AdminShell></ProtectedRoute>} />
        <Route path="inventory" element={<ProtectedRoute><AdminShell><Inventory /></AdminShell></ProtectedRoute>} />
        <Route path="categories" element={<ProtectedRoute><AdminShell><Categories /></AdminShell></ProtectedRoute>} />
        <Route path="zones" element={<ProtectedRoute><AdminShell><Zones /></AdminShell></ProtectedRoute>} />
        <Route path="reservations" element={<ProtectedRoute><AdminShell><Reservations /></AdminShell></ProtectedRoute>} />
        <Route path="drivers" element={<ProtectedRoute><AdminShell><Drivers /></AdminShell></ProtectedRoute>} />
        <Route path="tax-report" element={<ProtectedRoute><AdminShell><TaxReport /></AdminShell></ProtectedRoute>} />
        <Route path="content" element={<ProtectedRoute><AdminShell><SiteContent /></AdminShell></ProtectedRoute>} />
        <Route path="refunds" element={<ProtectedRoute><AdminShell><RefundQueue /></AdminShell></ProtectedRoute>} />
        <Route path="change-requests" element={<ProtectedRoute><AdminShell><ChangeRequests /></AdminShell></ProtectedRoute>} />
        <Route path="inbox" element={<ProtectedRoute><AdminShell><OwnerInbox /></AdminShell></ProtectedRoute>} />
        <Route path="booking-settings" element={<ProtectedRoute><AdminShell><BookingSettings /></AdminShell></ProtectedRoute>} />
        <Route path="message-templates" element={<ProtectedRoute><AdminShell><MessageTemplates /></AdminShell></ProtectedRoute>} />
        <Route path="run-sheet" element={<ProtectedRoute><AdminShell><RunSheet /></AdminShell></ProtectedRoute>} />
        <Route path="promo-codes" element={<ProtectedRoute><AdminShell><PromoCodes /></AdminShell></ProtectedRoute>} />
        <Route path="partners" element={<ProtectedRoute><AdminShell><Partners /></AdminShell></ProtectedRoute>} />
        <Route path="payout-scenarios" element={<ProtectedRoute><AdminShell><PayoutScenarios /></AdminShell></ProtectedRoute>} />
        <Route path="labels" element={<ProtectedRoute><AdminShell><Labels /></AdminShell></ProtectedRoute>} />
        <Route path="third-party-labels" element={<ProtectedRoute><AdminShell><ThirdPartyLabels /></AdminShell></ProtectedRoute>} />
        <Route path="scan" element={<ProtectedRoute><AdminShell><DriverScan /></AdminShell></ProtectedRoute>} />
        <Route path="my-route" element={<ProtectedRoute><AdminShell><MyRoute /></AdminShell></ProtectedRoute>} />
        <Route path="route-builder" element={<ProtectedRoute><AdminShell><RouteBuilder /></AdminShell></ProtectedRoute>} />
        <Route path="stage-prep" element={<ProtectedRoute><AdminShell><StagePrep /></AdminShell></ProtectedRoute>} />
        <Route path="payouts" element={<ProtectedRoute><AdminShell><Payouts /></AdminShell></ProtectedRoute>} />
        <Route path="blog" element={<ProtectedRoute><AdminShell><BlogPosts /></AdminShell></ProtectedRoute>} />
        <Route path="notifications" element={<ProtectedRoute><AdminShell><NotificationCenter /></AdminShell></ProtectedRoute>} />
        <Route path="calendar-settings" element={<Navigate to="/admin/calendar" replace />} />
      </Routes>
    </>
  );
};
